module.exports = "<div class=\"language\">\n\t<nav class=\"language__nav\" ng-class=\"{'active': $ctrl.active}\">\n\t\t<ul class=\"list-unstyled components pr-2\">\n\t\t\t<li\n\t\t\t\tng-repeat=\"item in $ctrl.elements\"\n\t\t\t\tng-class=\"{'active': $ctrl.selectedLanguage.id === item.id}\"\n\t\t\t\tclass=\"p-2 text-center\"\n\t\t\t\tng-click=\"$ctrl.onChange({$event:{languaje: item}})\"\n\t\t\t>\n\t\t\t\t<img\n\t\t\t\t\tng-src=\"/img/flags/{{ item.id }}.svg\"\n\t\t\t\t\tclass=\"img-thumbnail mb-1 menu__logo__preview\"\n\t\t\t\t/>\n\t\t\t</li>\n\t\t</ul>\n\t</nav>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/language/language.html
// module id = 605
// module chunks = 0